import { Link, useStaticQuery, graphql } from "gatsby"
import React, { useState } from "react"
import "./header.css"
import TagLink from "../components/tagLink"
import { useLocation } from "@reach/router";

const CursorMenu = ({ title, className, onClick, expanded }) => {
  return (
    <div
      className={`${
        expanded && "flex-row-reverse justify-end"
      } flex items-center justify-start lg:justify-start lg:flex-row gap-2 ${
        className || ""
      }`}
      onClick={onClick}
    >
      {title}
      <div className={`${expanded ? "rotate-90" : "-rotate-90"} lg:rotate-0`}>
        <svg
          width="8"
          height="5"
          viewBox="0 0 8 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.74349 0.538452L0.85426 0.538452C0.647625 0.538452 0.532245 0.756625 0.660212 0.90557L4.10483 4.89981C4.20342 5.01414 4.39328 5.01414 4.49292 4.89981L7.93754 0.90557C8.06551 0.756625 7.95013 0.538452 7.74349 0.538452Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  )
}

function Header() {
  const [isExpanded, toggleExpansion] = useState(false)
  // TODO: 更新関数はリファクタリングしたほうがよい
  const [categoryExpanded, toggleCategoryExpansion] = useState(false)
  const [searchExpanded, toggleSearchExpansion] = useState(false)
  const [assignmentExpanded, toggleAssignmentExpansion] = useState(false)
  const [measuresExpanded, toggleMeasuresExpansion] = useState(false)
  const [toolsExpanded, toggleToolsExpansion] = useState(false)
  const [industryExpanded, toggleIndustryExpansion] = useState(false)

  const location = useLocation(); // 現在のページ情報を取得
  const isHomePage = location.pathname === `${__PATH_PREFIX__}/` || location.pathname === "/"; // トップページ判定

  const data = useStaticQuery(graphql`
    query HeaderQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
      allMarkdownRemark(
        limit: 2000
        filter: { fields: { meta: { draft: { eq: false } } } }
      ) {
        group(field: frontmatter___tags) {
          fieldValue
        }
      }
      categoryTags: allTagsJson(
        filter: { type: { eq: "category" } }
        sort: { fields: priority, order: ASC }
      ) {
        nodes {
          name
          title
        }
      }
      assignmentTags: allTagsJson(
        filter: { type: { eq: "assignment" } }
        sort: { fields: priority, order: ASC }
      ) {
        nodes {
          name
          title
        }
      }
      marketingMeasuresTags: allTagsJson(
        filter: { type: { eq: "marketing-measures" } }
        sort: { fields: priority, order: ASC }
      ) {
        nodes {
          name
          title
        }
      }
      toolsChannelTags: allTagsJson(
        filter: { type: { eq: "tools-channel" } }
        sort: { fields: priority, order: ASC }
      ) {
        nodes {
          name
          title
        }
      }
      industryTags: allTagsJson(
        filter: { type: { eq: "industry" } }
        sort: { fields: priority, order: ASC }
      ) {
        nodes {
          name
          title
        }
      }
      allTagTypeJson {
        nodes {
          name
          title
        }
      }
    }
  `)

  const categoryTags = data.categoryTags.nodes
  const assignmentTags = data.assignmentTags.nodes
  const marketingMeasuresTags = data.marketingMeasuresTags.nodes
  const toolsChannelTags = data.toolsChannelTags.nodes
  const industryTags = data.industryTags.nodes

  const allUsedTags = data.allMarkdownRemark.group
  const filterUsedTag = tagList => {
    return tagList.filter(obj => {
      return !!allUsedTags.find(tag => tag.fieldValue === obj.name)
    })
  }

  const findTagTypeTitle = tagTypeName => {
    const tagTypeMetaData = data.allTagTypeJson.nodes.find(
      obj => obj.name === tagTypeName
    )
    return tagTypeMetaData.title
  }

  return (
    <div className="nav-wrapper">
      <nav className="pt-4 pl-6 pr-4 bg-gradient-to-b from-gradationNavy-from to-gradationNavy-to">
        <div className="max-w-screen-xl mx-auto">
          <span className="hidden lg:block text-brandGray text-xs tracking-wide mb-1">
            {data.site.siteMetadata.description}
          </span>
          <div className="flex flex-wrap items-end justify-between pb-4 lg:pb-0">
            <div className="flex items-center flex-shrink-0 lg:mr-7 lg:mb-4 text-white">
            {isHomePage ? (
          <h1 className="text-2xl font-bold uppercase">
            <Link to={`/`} className="text-white">
              {data.site.siteMetadata.title}
            </Link>
          </h1>
        ) : (
          <Link to={`/`} className="text-2xl font-bold uppercase">
            {data.site.siteMetadata.title}
          </Link>
        )}
            </div>
            <div className="block lg:hidden">
              <button
                onClick={() => toggleExpansion(!isExpanded)}
                className={`flex items-center px-3 py-2 text-white ${
                  isExpanded && `rotate-180`
                }`}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.293 7.293L9.99997 11.586L5.70697 7.293L4.29297 8.707L9.99997 14.414L15.707 8.707L14.293 7.293Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
            <div
              className={`${
                isExpanded ? `block` : `hidden`
              } w-full block flex-grow lg:flex lg:items-center lg:w-auto`}
            >
              <div className="text-sm lg:flex-grow lg:flex">
                <Link
                  to={`/tag/dx`}
                  className={`block mt-4 mr-6 lg:pb-4 text-white lg:inline-block lg:mt-0 hover:opacity-80 font-bold ${
                    categoryExpanded || searchExpanded ? `hidden` : `block`
                  }`}
                >
                  攻めのDX
                </Link>
                <Link
                  to={`/tag/cdp`}
                  className={`block mt-4 mr-6 lg:pb-4 text-white lg:inline-block lg:mt-0 hover:opacity-80 font-bold ${
                    categoryExpanded || searchExpanded ? `hidden` : `block`
                  }
                  `}
                >
                  CDP
                </Link>
                <div
                  className={`mt-4 mr-4 lg:mr-6 lg:pb-4 lg:inline-block text-white lg:mt-0 font-bold menu-has-children ${
                    searchExpanded ? `hidden` : `block`
                  }`}
                >
                  <CursorMenu
                    title={findTagTypeTitle("category")}
                    onClick={() => toggleCategoryExpansion(!categoryExpanded)}
                    expanded={categoryExpanded}
                  />
                  <div
                    className={`lg:bg-blue-950 lg:hidden sub-menu-block ${
                      categoryExpanded ? `block` : `hidden`
                    }`}
                  >
                    <div className="lg:max-w-screen-xl lg:mx-auto">
                      <div className="flex flex-wrap mt-2 lg:mt-0 items-center text-sm">
                        {filterUsedTag(categoryTags).map(e => (
                          <Link
                            key={e.name}
                            to={`/tag/${e.name}`}
                            href={`/tag/${e.name}`}
                            className="block p-1 pr-4 lg:p-4 text-white lg:inline-block font-bold lg:mt-0 hover:opacity-80"
                          >
                            {e.title}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`mt-4 mr-4 lg:mr-6 lg:pb-4 text-white lg:mt-0 font-bold menu-has-children ${
                    categoryExpanded ? `hidden` : `block`
                  } lg:block`}
                >
                  <CursorMenu
                    title="記事をさがす"
                    onClick={() => toggleSearchExpansion(!searchExpanded)}
                    expanded={searchExpanded}
                    className={`${
                      assignmentExpanded ||
                      measuresExpanded ||
                      toolsExpanded ||
                      industryExpanded
                        ? `hidden`
                        : `block`
                    } lg:flex`}
                  />
                  <div
                    className={`lg:bg-blue-950 lg:hidden sub-menu-block ${
                      searchExpanded ? `block` : `hidden`
                    } lg:block`}
                  >
                    <div className="lg:max-w-screen-xl lg:mx-auto">
                      <div className="lg:flex flex-wrap items-center text-sm">
                        <div
                          className={`mt-2 lg:mt-0 sub-menu-has-children ${
                            measuresExpanded ||
                            toolsExpanded ||
                            industryExpanded
                              ? `hidden`
                              : `block`
                          } lg:block`}
                        >
                          <CursorMenu
                            title={`${findTagTypeTitle("assignment")}から探す`}
                            className="pl-2 pt-1 pb-1 lg:p-4 hover:opacity-80"
                            onClick={() =>
                              toggleAssignmentExpansion(!assignmentExpanded)
                            }
                            expanded={assignmentExpanded}
                          />
                          <div
                            className={`lg:bg-blue-950 pb-4 lg:hidden sub-menu-block ${
                              assignmentExpanded ? `block` : `hidden`
                            }`}
                          >
                            <div className="lg:max-w-screen-xl lg:mx-auto">
                              <div className="flex flex-wrap mt-3 lg:mt-0 lg:pl-6 lg:pr-6 items-center flex-gap-2">
                                {filterUsedTag(assignmentTags).map(tag => (
                                  <TagLink
                                    name={tag.name}
                                    title={tag.title}
                                    key={`tag-list-${tag.name}`}
                                    size={"m"}
                                  />
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`mt-2 lg:mt-0 sub-menu-has-children ${
                            assignmentExpanded ||
                            toolsExpanded ||
                            industryExpanded
                              ? `hidden`
                              : `block`
                          } lg:block`}
                        >
                          <CursorMenu
                            title={`${findTagTypeTitle(
                              "marketing-measures"
                            )}から探す`}
                            className="pl-2 pt-1 pb-1 lg:p-4 hover:opacity-80"
                            onClick={() =>
                              toggleMeasuresExpansion(!measuresExpanded)
                            }
                            expanded={measuresExpanded}
                          />
                          <div
                            className={`lg:bg-blue-950 pb-4 lg:hidden sub-menu-block ${
                              measuresExpanded ? `block` : `hidden`
                            }`}
                          >
                            <div className="lg:max-w-screen-xl lg:mx-auto">
                              <div className="flex flex-wrap mt-3 lg:mt-0 lg:pl-6 lg:pr-6 items-center flex-gap-2">
                                {filterUsedTag(marketingMeasuresTags).map(
                                  tag => (
                                    <TagLink
                                      name={tag.name}
                                      title={tag.title}
                                      key={`tag-list-${tag.name}`}
                                      size={"m"}
                                    />
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`mt-2 lg:mt-0 sub-menu-has-children ${
                            assignmentExpanded ||
                            measuresExpanded ||
                            industryExpanded
                              ? `hidden`
                              : `block`
                          } lg:block`}
                        >
                          <CursorMenu
                            title={`${findTagTypeTitle(
                              "tools-channel"
                            )}から探す`}
                            className="pl-2 pt-1 pb-1 lg:p-4 hover:opacity-80"
                            onClick={() => toggleToolsExpansion(!toolsExpanded)}
                            expanded={toolsExpanded}
                          />
                          <div
                            className={`lg:bg-blue-950 pb-4 lg:hidden sub-menu-block ${
                              toolsExpanded ? `block` : `hidden`
                            }`}
                          >
                            <div className="lg:max-w-screen-xl lg:mx-auto">
                              <div className="flex flex-wrap mt-3 lg:mt-0 lg:pl-6 lg:pr-6 items-center flex-gap-2">
                                {filterUsedTag(toolsChannelTags).map(tag => (
                                  <TagLink
                                    name={tag.name}
                                    title={tag.title}
                                    key={`tag-list-${tag.name}`}
                                    size={"m"}
                                  />
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`mt-2 lg:mt-0 sub-menu-has-children ${
                            assignmentExpanded ||
                            measuresExpanded ||
                            toolsExpanded
                              ? `hidden`
                              : `block`
                          } lg:block`}
                        >
                          <CursorMenu
                            title={`${findTagTypeTitle("industry")}から探す`}
                            className="pl-2 pt-1 pb-1 lg:p-4 hover:opacity-80"
                            onClick={() =>
                              toggleIndustryExpansion(!industryExpanded)
                            }
                            expanded={industryExpanded}
                          />
                          <div
                            className={`lg:bg-blue-950 pb-4 lg:hidden sub-menu-block ${
                              industryExpanded ? `block` : `hidden`
                            }`}
                          >
                            <div className="lg:max-w-screen-xl lg:mx-auto">
                              <div className="flex flex-wrap mt-3 lg:mt-0 lg:pl-6 lg:pr-6 items-center flex-gap-2">
                                {filterUsedTag(industryTags).map(tag => (
                                  <TagLink
                                    name={tag.name}
                                    title={tag.title}
                                    key={`tag-list-${tag.name}`}
                                    size={"m"}
                                  />
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Link
                  to={`/tag/cases`}
                  className={`block mt-4 mr-6 lg:pb-4 text-white lg:inline-block lg:mt-0 hover:opacity-80 font-bold ${
                    categoryExpanded || searchExpanded ? `hidden` : `block`
                  }`}
                >
                  事例
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Header
